import { connect } from 'react-redux'
import SystemCheck from './SystemCheck'
import { State } from '../../dataStore/reducers/reducerType'

const mapStateToProps = (state: State, props) => ({
  ...props,
  inProgress: state.qualityCheck.qualityCheckInProgress,
  report: state.qualityCheck.qualityReport,
  failed: state.qualityCheck.qualityCheckFailed
})
const mapDispatchToProps = dispatch => ({})

export default connect(mapStateToProps, mapDispatchToProps)(SystemCheck)
